export function checkOCCO(operationModes: string[]) {
    return [
        'Open/close',
        'On/off',
        'Changeover',
    ].filter((v) => (operationModes || []).includes(v)).length === 0;
}

export function isSteam(Fluid: string[]) {
    return (Fluid || []).includes('Steam');
}

export function checkPd(shortValveType: string[]) {
    return [
        'CV',
        'BV',
        'CCV',
        '6-way CCV',
        '6-way QCV',
        'QCV',
        'BFV',
        'GV',
        'ZV',
    ].filter((v) => (shortValveType || []).includes(v)).length > 0;
}

export function check6Way(shortValveType: string[]) {
    return (shortValveType || [])
    .filter((v) => v.substring(0, 5).toLowerCase() === '6-way')
        .length > 0;
}
